import { useEffect, useState, useRef, useLayoutEffect } from 'react';
import { Box, Container, Paper, CircularProgress, Typography, Chip } from '@mui/material';
import moment from 'moment';
import ShoppingCard from './shoppingCard';
import { useGetListProductsMutation } from '../../services/orders';
import Filter from './filter';
import { Search } from '@mui/icons-material';

const pagesize = 15;
let num = 0, productGroup = [], saleType = [], sorting = "0", search = "";

export default function Orders() {
  const [getListProducts, dataProducts] = useGetListProductsMutation();
  const [products, setProducts] = useState([]);
  const containerRef = useRef(null);
  const [fullloaded, setFullloaded] = useState(false);

  useEffect(() => {
    num = 0;
    getData(false);
  }, []);

  useEffect(() => {
    if(dataProducts.data)
    {
      const dt = JSON.parse(dataProducts.data);
      if(dt.length > 0 && dt[0].num > num){
        setProducts([...products, ...dt]);
        num = dt[dt.length - 1].num;
      }
      if(dt.length < pagesize){//full loaded
        setFullloaded(true);
      }
    }
  }, [dataProducts]);

  const handleScroll = () => {
    const { scrollTop, scrollHeight, clientHeight } = containerRef.current;
    if (scrollTop + clientHeight >= scrollHeight - 150/* && !loading*/) {
      loadMore();
    }
  };

  const loadMore = () => {
    if(!dataProducts.isLoading && !fullloaded){
      getData(false);
    }
  };

  const getData = (filter) => {
    if(filter){
      productGroup = filter.productGroup;
      saleType = filter.saleType;
      sorting = filter.sorting;
      search = filter.search;
      num = 0;
      setFullloaded(false);
      setProducts([]);
    }
    
    getListProducts({pagesize: pagesize, num: num, productGroup: productGroup.toString()
      , saleType: saleType.toString(), sorting: sorting, search: search});
  };

  useEffect(() => {
    const container = containerRef.current;
    container.addEventListener("scroll", handleScroll);
    return () => container.removeEventListener("scroll", handleScroll);
  });

  return (
    <Container maxWidth="xl" sx={{ p: {xs: 0, md: 0}}}>
      <Filter getData = {getData} />
      <Paper
        ref={containerRef}
        sx={{
          pl: '10px', pr: '10px', pb: {xs: 4, md: 2},
          height: { xs: "calc(100vh - 160px)", md: "calc(100vh - 116px)" },
          overflowY: "auto",
          position: "relative",
          border: 'none'
        }}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "repeat(2, 1fr)",
              md: "repeat(3, 1fr)",
              lg: "repeat(4, 1fr)",
              xl: "repeat(5, 1fr)"
            },
            gap: 2, // spacing between cards
            maxWidth: 1600, // central "apartment" width
            mx: "auto", // centers grid horizontally
            mt: 4, // margin-top
          }}
        >
          {products.map((product, index) => (
            <ShoppingCard product={product} />
          ))}
        </Box>

        {dataProducts.isLoading && (
          <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
            <CircularProgress size={28} />
          </Box>
        )}
        {fullloaded && (
          <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
            <Typography sx={{ color: 'gray' }}>
              Không còn sản phẩm nào khác
            </Typography>
          </Box>
        )}
      </Paper>
    </Container>
  )
}